'use client';

import ProxyImage from '@shared/ProxyImage/ProxyImage';
import classNames from '@sindresorhus/class-names';
import {useEffect, useState} from 'react';

import {CareerPageIntro} from '@strapi/types/Career';

import styles from './AnimatedBanner.module.scss';

export const AnimatedBanner = ({
  intro,
  className,
}: {
  intro: CareerPageIntro;
  className: string;
}) => {
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    setAnimate(true);
  }, []);
  return (
    <h1
      className={classNames(
        styles.root,
        className,
        !animate && styles.stopAnimations,
      )}
    >
      <div className={styles.titleWord1}>{intro.titleWord1}</div>
      <span className="visually-hidden"> </span>
      <div className={styles.middleRow}>
        <div className={styles.titleWord2}>{intro.titleWord2}</div>
        <span className="visually-hidden"> </span>
        <div className={styles.titleWord3}>{intro.titleWord3}</div>
        <span className="visually-hidden"> </span>
      </div>
      <div className={styles.titleWord4}>{intro.titleWord4}</div>
      <ProxyImage imageData={intro.topImage} className={styles.topImage} />
      <ProxyImage
        imageData={intro.bottomImage}
        className={styles.bottomImage}
      />
    </h1>
  );
};
